<section id="project1" class="projects" data-scroll-nav="0">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row">
          <div class="col-xl-7 col-md-7 col-sm-6" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <div class="d-flex flex-column justify-content-center h-100 service-content">
              <div>
                <h1 class="heading">Pakhi's</h1>
                <div class="points">
                  <p>Pakhi’s is a testament to the enchanting blend of heritage & modernity that the Middle East
                    represents.</p>
                  <p> <a class="text-decoration-underline" href="https://www.pakhis.ae/" target="_blank">Pakhis.ae</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-5 col-md-5 col-sm-6">
            <div class="d-flex flex-column justify-content-center align-items-sm-end">
              <div class="list-block">
                <h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"><a
                    href="{{Url}}/project-details/pakhis#branding">Branding</a></h3>
                <h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="150"><a
                    href="{{Url}}/project-details/pakhis#productdesign">Product Design</a></h3>
                <!-- <h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="2500" data-aos-delay="250"><a
                    href="{{Url}}/project-details/dnour#socialmedia">Social Media</a></h3> -->
                <h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"><a
                    href="{{Url}}/project-details/pakhis#ui-ux">UI/UX Design</a></h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section data-scroll-nav="1" class="pb-0">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12 p-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
        <img src="{{baseUrl}}/images/projects/pakhis/banner-min.jpg" alt="Best Web Designers in Dubai" width="" height="" loading="lazy">
      </div>
    </div>
  </div>
</section>
<section class="section bg-pakhis pb-5" data-scroll-nav="2">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto" data-aos="fade-up"
        data-aos-duration="2000" data-aos-delay="100">
        <div class="content">
          <p class="mb-5">"Pakhi's" presents a luxurious and sustainable handwash collection inspired by the enchanting
            charm of the Middle East. Our handcrafted formulations are meticulously designed to unveil the secrets of
            nourished and rejuvenated skin. Each product embodies a unique blend of tradition, innovation, and care,
            providing an unparalleled sense of luxury to your everyday self-care routine. </p>

          <h3 class="semibold subheading mb-1">Project Objectives:</h3>
          <p class="mb-0">Creating an online platform for Pakhi's premium hand wash collection, emphasizing UAE's
            cultural and sensory aspects.</p>
          <p class="mb-0"> We aim to develop a user-friendly, mobile-responsive website for an enhanced online shopping
            experience.</p>
          <p class="mb-0">Furthermore, the platform will convey the brand's commitment to high quality, sustainability,
            and affordability.</p>
          <!-- <p class="mb-4">Create an online platform to showcase and sell Pakhi's luxurious hand wash collection.</p>
          <p class="mb-4">Emphasize the cultural and sensory aspects of the Middle East in the product presentation.</p>
          <p class="mb-4">Develop a user-friendly and mobile-responsive website to enhance the online shopping
            experience.</p>
          <p class="mb-4">Convey the brand's commitment to high quality, sustainability, and affordability.</p> -->
        </div>
        <div class="row mt-5">
          <div class="col-xxl-10 col-xl-12 col-lg-12 col-md-12 col-sm-12" data-aos="fade-up" data-aos-duration="2000"
            data-aos-delay="100">
            <div class="content">
              <h1 class="heading mb-2">Branding</h1>
              <!-- <p class="">Pakhis crafted a distinctive logo, premium quality visiting cards, invoice covers, and other
                corporate branding materials.</p> -->
              <p>In shaping the branding strategy for "Pakhis," our approach involved
                a thorough exploration of the agency's identity. Through in-depth
                consultations and market analysis, we crafted a distinctive brand
                narrative and visual identity aligned with Pakhis' core values. The
                result is a sophisticated and resonant brand image, strategically
                positioned to leave a lasting impression on its audience. Our
                commitment to precision, creativity, and strategic thinking
                underscores the success of this collaborative endeavor, contributing to
                Pakhis' emergence as a distinguished entity within its industry</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
<section class="bg-pakhis branding" id="branding" data-scroll-nav="3">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 p-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
        <div class="imglist mb-3">
          <img src="{{baseUrl}}/images/projects/pakhis/pakhis-detail.jpg" alt="project1" width="" height="" loading="lazy">
        </div>
      </div>
      <div class="col-xxl-10 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto ps-md-0" data-aos="fade-up" data-aos-duration="2000"
            data-aos-delay="100">
            <img src="{{baseUrl}}/images/projects/pakhis/stationery-Mockup-min.jpg" alt="graphic design company" width="" height="" loading="lazy">
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 ps-md-0" data-aos="fade-up" data-aos-duration="2000"
            data-aos-delay="100">
            <div class="list">
              <img src="{{baseUrl}}/images/projects/pakhis/broken-plank.jpg" alt="ecommerce website design in dubai" width="" height="" loading="lazy">
              <img src="{{baseUrl}}/images/projects/pakhis/duct-tape-mockup-min.jpg" alt="web development dubai" width="" height="" loading="lazy">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-pakhis typography" data-scroll-nav="5">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="typography" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
          <img src="{{baseUrl}}/images/projects/pakhis/typography.png" alt="website developers in dubai" width="" height="" loading="lazy">
          <p data-aos="fade-up" data-aos-duration="2500" data-aos-delay="100">The visual design of the website embodies
            the essence of luxury and the mystique of the Middle East.</p>
          <h3 class="semibold subheading">Color Schemes:</h3>
          <p>Rich and opulent color palettes reflective of the cultural richness of the Middle East.</p>

          <h3 class="semibold subheading">Typography:</h3>
          <p>Elegant and legible fonts to enhance readability and convey a sense of sophistication.</p>

          <h3 class="semibold subheading">Imagery:</h3>
          <p>High-quality, curated visuals showcasing the hand wash collection and the cultural inspiration behind each
            variant.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-pakhis package" id="productdesign" data-scroll-nav="6">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row mb-4">
          <div class="col-xxl-10 col-xl-12 col-lg-12 col-md-12 col-sm-12" data-aos="fade-up" data-aos-duration="2000"
            data-aos-delay="100">
            <div class="content">
              <h1 class=" heading mb-2">Product Design</h1>
              <!-- <p class="">Branding is a strategic dance of logos, colors, and more, shaping a unique identity
                and perception in consumers' minds. It sets a brand apart, evoking emotions and building trust.</p> -->
              <p>In crafting the product design for "Pakhis," we seamlessly blended
                creativity and functionality. Our approach, rooted in the agency's
                vision, resulted in a distinct hand wash collection that embodies the
                premium quality and cultural essence of the UAE. Through thoughtful
                ideation and design iterations, each product within Pakhis' collection
                speaks to the brand's commitment to excellence, reflecting qualities of
                quality, sustainability, and affordability. This collaborative effort
                establishes Pakhis as a standout brand, resonating with the discerning
                tastes of its audience.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-5">
            <img src="{{baseUrl}}/images/projects/pakhis/all-three-podium-sand.jpg" alt="Top creative agencies in dubai" width="" height="" loading="lazy"
              class="img1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
          </div>
          <div class="col-md-12">
            <img src="{{baseUrl}}/images/projects/pakhis/threebottles-min.png" alt="best design agency" width="" height="" loading="lazy" class="img2"
              data-aos="fade-up" data-aos-duration="2500" data-aos-delay="150">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="section ui-ux" id="ui-ux" data-scroll-nav="8">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row mb-4">
          <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10" data-aos="fade-up" data-aos-duration="2000"
            data-aos-delay="100">
            <div class="content">
              <h1 class="heading mb-2">UI/UX Design</h1>
              <p class="">Branding is a strategic dance of logos, colors, and more, shaping a unique identity and
                perception in consumers' minds. It sets a brand apart, evoking emotions and building trust.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-9 mx-lg-auto" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <!-- <img src="{{baseUrl}}/images/projects/pakhis/imac.png" alt="website development company dubai" width="" height=""
              class="desktopimg"> -->
            <video class="w-100 h-auto desktopimg" id="myVideo3" width="320" height="176" autoplay="true" muted="muted"
              loop="true" oncanplay="this.play()" onloadedmetadata="this.muted = true">
              <source src="{{baseUrl}}/images/projects/pakhis/pakhis-imac-scroll.mp4" type="video/mp4">
              <source src="{{baseUrl}}/images/projects/pakhis/pakhis-imac-scroll.ogg" type="video/ogg">
              Your browser does not support HTML5 video.
            </video>

            <!-- <img src="{{baseUrl}}/images/projects/pakhis/laptop.png" alt="Top branding agency in Dubai" width="" height=""> -->
            <video class="w-100 h-auto" id="myVideo3" width="320" height="176" autoplay="true" muted="muted" loop="true"
              oncanplay="this.play()" onloadedmetadata="this.muted = true">
              <source src="{{baseUrl}}/images/projects/pakhis/pakhis-laptop-scroll.mp4" type="video/mp4">
              <source src="{{baseUrl}}/images/projects/pakhis/pakhis-laptop-scroll.ogg" type="video/ogg">
              Your browser does not support HTML5 video.
            </video>
            <p class="mb-md-4 mb-sm-3 mb-2">The design and development process focused on seamlessly integrating tradition, innovation,
              and user-friendly functionality.</p>
            <p class="mb-md-4 mb-sm-3 mb-2">Conducted market research to understand user preferences for luxury self-care products.</p>
            <p class="mb-md-4 mb-sm-3 mb-2">Collaborated with stakeholders to define the brand identity and values.</p>
            <p class="mb-md-4 mb-sm-3 mb-2">Utilized HTML 5 and Bootstrap for a responsive and visually appealing website.</p>
            <p class="mb-md-4 mb-sm-3 mb-2">Emphasized user experience and easy navigation to facilitate a smooth browsing and shopping
              journey.</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<section class="technical" id="technical" data-scroll-nav="8">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row mb-4">
          <div class="col-xxl-10 col-xl-12 col-lg-12 col-md-12 col-sm-12" data-aos="fade-up" data-aos-duration="2000"
            data-aos-delay="100">
            <div class="content">
              <h1 class="heading mb-2">Technical Stack</h1>
              <h3 class="semibold subheading mb-3"> The technological stack of Pakhi's website included:</h3>
              <p class="mb-md-4 mb-sm-3 mb-2">HTML 5: Ensuring a robust and structurally sound foundation.</p>
              <p class="mb-md-4 mb-sm-3 mb-2">Bootstrap: Facilitating a responsive and mobile-friendly design.</p>
              <p class="mb-md-4 -sm-3 mb-2">Fully Mobile Responsive: Adapting seamlessly to various devices for an optimal user experience.</p>
                <p>User-Friendly: Implementing intuitive navigation and user interfaces.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="next bg-black pb-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="next-block">
          <div class="in-line">
            <a href="{{Url}}/project-details/beyou" class="text-white font-bold">
              <img src="{{baseUrl}}/images/projects/dnour/pixtar-case-study-web-design.png" alt="web designing agency dubai" width="280"
                height="280" loading="lazy">
              <h1 class="heading text-white">NEXT
                PROJECT</h1>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
  </div>
</section>